import React from 'react';

const ReactionDisplay = ({ reactions, onReactionClick, currentUserId }) => {
  if (!reactions || Object.keys(reactions).length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(reactions).map(([emoji, userIds]) => {
        const count = Array.isArray(userIds) ? userIds.length : 0;
        const hasReacted = currentUserId && Array.isArray(userIds) && userIds.includes(currentUserId);

        if (count === 0) return null;

        return (
          <button
            key={emoji}
            onClick={() => onReactionClick(emoji)}
            className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-sm border ${
              hasReacted
                ? 'bg-primary-50 border-primary-300 text-primary-700'
                : 'bg-secondary-50 border-secondary-200 text-secondary-700 hover:bg-secondary-100'
            }`}
            title={`${count} reaction${count !== 1 ? 's' : ''}`}
          >
            <span>{emoji}</span>
            <span className="font-medium">{count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionDisplay;
